import { Routes } from '@angular/router';
import {
  RenderInterfaceGuard
} from 'viggo-sistemas-core-web';

export const routesDeposito: Routes = [
  {
    path: 'depositos',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      menuKey: 'DEPOSITO',
      subMenuKey: 'CADASTRO_DEPOSITO',
      module: 'DEPOSITO',
      breadcrumb: {
        label: 'Cadastro depósito',
        icon: 'mdi mdi-store-plus-outline'
      },
      backend_path: '/depositos'
    },
    loadChildren: () =>
      import('@app/modules/deposito/deposito.module').then(
        m => m.DepositoModule
      )
  },
  {
    path: 'entrada_deposito',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      menuKey: 'DEPOSITO',
      subMenuKey: 'REE_DEPOSITO',
      module: 'REE_DEPOSITO',
      breadcrumb: {
        label: 'Entrada de estoque no depósito',
        icon: 'mdi mdi-archive-arrow-down-outline'
      },
      backend_path: '/ree_depositos'
    },
    loadChildren: () =>
      import('@app/modules/entrada-depositos/entrada-depositos.module').then(
        m => m.EntradaDepositoModule
      )
  },
  {
    path: 'saida_deposito',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      menuKey: 'DEPOSITO',
      subMenuKey: 'RSE_DEPOSITO',
      module: 'RSE_DEPOSITO',
      breadcrumb: {
        label: 'Saída de estoque no depósito',
        icon: 'mdi mdi-archive-arrow-up-outline'
      },
      backend_path: '/rse_depositos'
    },
    loadChildren: () =>
      import('@app/modules/saida-depositos/saida_deposito.module').then(
        m => m.SaidaDepositoModule
      )
  },
  {
    path: 'transferencia_deposito',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      menuKey: 'DEPOSITO',
      subMenuKey: 'TRANSF_DEPOSITO',
      module: 'TRANSF_DEPOSITO',
      breadcrumb: {
        label: 'Transferência entre depósitos',
        icon: 'mdi mdi-bank-transfer'
      },
      backend_path: '/transf_depositos'
    },
    loadChildren: () =>
      import('@app/modules/transf-depositos/transf-depositos.module').then(
        m => m.TransfDepositoModule
      )
  },
];
